import Vue from 'vue';
import VueHtmlToPaper from 'vue-html-to-paper';
import App from './App.vue';
import { router } from './router';
import store from './store';
// import 'bootstrap';
// import 'bootstrap/dist/css/bootstrap.min.css';
import VeeValidate from 'vee-validate';
import Vuex from 'vuex';
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import LoadScript from 'vue-plugin-load-script';
import CommonServices from './services/common-services'
import VueLoading from 'vue-loading-overlay';

import 'bootstrap/dist/css/bootstrap.min.css'
import 'jquery/src/jquery.js'
import 'bootstrap/dist/js/bootstrap.min.js'
import 'vue-loading-overlay/dist/vue-loading.css';
import { abilitiesPlugin } from '@casl/vue';
import {ability} from './services/ability'

import {
  faHome,
  faUser,
  faUserPlus,
  faSignInAlt,
  faSignOutAlt
} from '@fortawesome/free-solid-svg-icons';

library.add(faHome, faUser, faUserPlus, faSignInAlt, faSignOutAlt);

Vue.config.productionTip = false;
Vue.use(abilitiesPlugin,ability);
Vue.use(VeeValidate);
Vue.component('font-awesome-icon', FontAwesomeIcon);

Vue.use(Vuex);
Vue.use(LoadScript);
Vue.use(VueLoading,{
    loader: 'Bars',
    height:160,
    width: 110,
    color: '#34B2D0',
    canCancel: false
    });

/* Vue.loadScript(CommonServices.local_asset_url("assets/js/jquery-1.10.2.min.js"));
Vue.loadScript(CommonServices.local_asset_url("assets/js/jqueryui-1.10.3.min.js"));
Vue.loadScript(CommonServices.local_asset_url("assets/js/bootstrap.min.js"));*/
Vue.loadScript(CommonServices.local_asset_url("assets/js/enquire.min.js"));
Vue.loadScript(CommonServices.local_asset_url("assets/plugins/velocityjs/velocity.min.js"));
Vue.loadScript(CommonServices.local_asset_url("assets/plugins/velocityjs/velocity.ui.min.js"));
Vue.loadScript(CommonServices.local_asset_url("assets/plugins/progress-skylo/skylo.js"));
Vue.loadScript(CommonServices.local_asset_url("assets/plugins/wijets/wijets.js"));
Vue.loadScript(CommonServices.local_asset_url("assets/plugins/sparklines/jquery.sparklines.min.js"));
Vue.loadScript(CommonServices.local_asset_url("assets/plugins/codeprettifier/prettify.js"));
Vue.loadScript(CommonServices.local_asset_url("assets/plugins/bootstrap-tabdrop/js/bootstrap-tabdrop.js"));
Vue.loadScript(CommonServices.local_asset_url("assets/plugins/nanoScroller/js/jquery.nanoscroller.min.js"));
Vue.loadScript(CommonServices.local_asset_url("assets/plugins/dropdown.js/jquery.dropdown.js"));
Vue.loadScript(CommonServices.local_asset_url("assets/plugins/bootstrap-material-design/js/material.min.js"));
Vue.loadScript(CommonServices.local_asset_url("assets/plugins/bootstrap-material-design/js/ripples.min.js"));

Vue.loadScript(CommonServices.local_asset_url("assets/js/Utility_ApplicationUsed.js"));
/* Vue.loadScript(CommonServices.local_asset_url("assets/js/application.js"));*/

const options = {
  name: '_blank',
  specs: [
    'fullscreen=yes',
    'titlebar=yes',
    'scrollbars=yes'
  ],
  styles: [
    'https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css',
    'https://unpkg.com/kidlat-css/css/kidlat.css'
  ],
  timeout: 1000, // default timeout before the print window appears
  autoClose: true, // if false, the window will not close after printing
  windowTitle: window.document.title, // override the window title
}

Vue.use(VueHtmlToPaper, options);
/* Vue.loadScript("assets/js/application.js");
 Vue.loadScript("assets/demo/demo.js");
 Vue.loadScript("assets/demo/demo-switcher.js");

 Vue.loadScript("assets/demo/demo-index.js") */

new Vue({
  router,
  store,
  render: h => h(App),
  watch:{
    '$router' (to) {
       if(to.currentRoute.meta.reload==true){window.location.reload()}
   }}
}).$mount('#ab-app');

Vue.mixin({
  created() {
  },
  methods:{
    skyloStart(){
      if (typeof $ !== 'undefined' && typeof $.skylo === 'function') {
        $.skylo('start');
        $.skylo('set', 80);
      }
    },
    skyloEnd(){
      if (typeof $ !== 'undefined' && typeof $.skylo === 'function') {
        $.skylo('end');
      }
    }
  }
});
